import { render, staticRenderFns } from "./user.vue?vue&type=template&id=c1e47ea6&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style1 from "./user.vue?vue&type=style&index=1&id=c1e47ea6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e47ea6",
  null
  
)

export default component.exports